var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJira(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8693 22.6563L26.2144 2.00139L24.213 0L8.66451 15.5485L1.55451 22.6563C0.815163 23.3996 0.815163 24.6004 1.55451 25.3435L15.7595 39.5485L24.2132 48L39.7595 32.4515L40.0017 32.2115L46.8695 25.3543C47.6145 24.6148 47.619 23.4112 46.8794 22.6663C46.8761 22.663 46.8728 22.6596 46.8695 22.6563H46.8693ZM24.213 31.097L17.1158 23.9998L24.213 16.9026L31.308 23.9998L24.213 31.097Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2136 16.9025C19.567 12.2572 19.5441 4.73135 24.1621 0.0576172L8.63281 15.5805L17.0843 24.032L24.2136 16.9027V16.9025Z",
    fill: "url(#paint0_linear_2291_2256)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3272 23.9807L24.2129 31.0971C28.8785 35.7638 28.8785 43.3289 24.2129 47.9956L39.7851 32.432L31.3272 23.9805V23.9807Z",
    fill: "url(#paint1_linear_2291_2256)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2291_2256",
    x1: 22.9887,
    y1: 9.75918,
    x2: 13.0763,
    y2: 19.6695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2291_2256",
    x1: 25.6136,
    y1: 38.2344,
    x2: 35.5067,
    y2: 28.3434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJira);
export default __webpack_public_path__ + "static/media/Jira.18df5d14bf3ed748cf3d69ba9d5d9eb5.svg";
export { ForwardRef as ReactComponent };